import { render, staticRenderFns } from "./ModifyNumber.vue?vue&type=template&id=adf1e5b8&scoped=true"
import script from "./ModifyNumber.vue?vue&type=script&lang=ts"
export * from "./ModifyNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf1e5b8",
  null
  
)

export default component.exports